"use client";

import { PasskeyProvider } from "@/contexts/PasskeyContext";
import { PageLayout } from "@/components/ui/PageLayout";
import { DemoFlow } from "./components/DemoFlow";
import Link from "next/link";

export default function DemoPasskeysPage() {
  return (
    <PasskeyProvider>
      <PageLayout className="">
        <div className="space-y-6 anim-fadeSlideInUp-500ms">
          <div className="mb-7 anim-fadeSlideInLeft-500ms" style={{ animationDelay: "0.2s" }}>
            <div className="flex items-center gap-3 mb-1">
              <h1 className="text-[28px] font-normal font-serif leading-tight">Passkey Smart Account</h1>
              <span
                className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[10px] tracking-[0.06em] font-medium"
                style={{ background: "rgba(217, 70, 239, 0.1)", color: "#d946ef", border: "1px solid rgba(217, 70, 239, 0.2)" }}
              >
                Non-Custodial Passkey Mode
              </span>
            </div>
            <p className="text-[11px] tracking-[0.04em]" style={{ color: "var(--text-tertiary)" }}>
              Deploy, fund, swap, and deposit into DeFi pools — authenticated with your biometric passkey.{" "}
              <Link href="/tests/demo" className="transition-colors" style={{ color: "var(--accent)" }}>
                Compare with Freighter demo
              </Link>
            </p>
          </div>

          <DemoFlow />
        </div>
      </PageLayout>
    </PasskeyProvider>
  );
}
